const en = {
	login: 'Log in',
	logout: 'Log out',
	signin: 'Sign in',
	signup: 'Sign up',
	email: 'email',
	emailAddr: 'Email Address',
	password: 'password',
	rememberMe: 'Remember Me',
	forgotYourPwd: 'Forgot your password?',
	signinFacebook: 'Sign in with Facebook',
	signinGoogle: 'Sign in with Google',
	dontAccount: 'Don\'t have an account?',
	firstName: 'First Name',
	lastName: 'Last Name',
	confirmPwd: 'confirm Password',
	signup_msg: 'By clicking join now, you agree to the',
	digitX_user_agreement: 'DigitXchange User Agreement',
	privacy_policy: 'Privacy Policy',
	and: ' and ',
	cookies_policy: 'Cookies Policy',
	have_account: 'Already have an account',
	forgotPwd: 'Forget Password',
	recoverPwd: 'RECOVER PASSWORD',
	forgotPwd_msg: 'Place your email in the field above, we will send you a link with the instructions to follow.',
	changePwd: 'Change Password',
	oldPwd: 'Old Password',
	newPwd: 'New Password',
	confirmNewPwd: 'Confirm New Password',
	user_account: 'User Account',
	change_pic: 'Change Picture',
	mobile_number: 'Mobile Number',
	country: 'Country',
	update_settings: 'update settings',
	company: 'Company',
	aboutUs: 'About Us',
	tos: 'TOS',
	copyright: 'Copyright',
	socialMedia: 'Social Media',
	forUpdates: 'for updates',
	footer_msg_1: 'By signing up you are accepting out',
	terms: 'Terms of Service',
	contactUs: 'Contact Us',
	yourEmail: 'Your Email',
	required: 'required',
	yourMsg: 'Your Message',
	sent: 'Sent',
	footer_msg_2: 'All right Reserved',
	footer_msg_3: 'All product names, trademarks and registered trademarks are property of their respective owners',
	doom: 'Doom III',
	filter: 'Filter',
	add_asset: 'Add Asset',
	request_game: 'Request Game',
	search_msg: 'Sorry, but nothing matched your search terms.',
	post: 'Post',
	asset: 'Asset',
	create: 'Create',
	character: 'Character',
	characters: 'Characters',
	assets: 'Assets',
	profile: 'Profile',
	game: 'Game',
	games: 'Games',
	currency: 'Currency',
	store: 'Store',
	all_time: 'All Time',
	this_month: 'This Month',
	trending: 'Trending',
	item_name: 'Item Name',
	view_item: 'View Item',
	leaderboard: 'Leaderboard',
	posters: 'Posters',
	chinese: 'Chinese',
	english: 'English',
	japanese: 'Japanese',
	korean: 'Korean',
	german: 'German',
	french: 'French',
	spanish: 'Spanish',
	italian: 'Italian',
	russian: 'Russian',
	portuguese: 'Portuguese',
	hindi: 'Hindi',
	arabic: 'Arabic',
	buy: 'Buy',
	subscription: 'Subscription',
	buy_subscription: 'Buy Subscription',
	gift: 'Gift',
	xchange: 'Xchange',
	subscription_plan: 'Subscription Plan',
	payment_options: 'Payment Options',
	cardholder_name: 'Cardholder Name',
	submit_order: 'Submit Order',
	card_number: 'Card Number',
	cvv: 'CVV',
	expiration_date: 'Expiration Date',
	buyXchange: 'Buy Xchange',
	giftXchange: 'Gift Xchange',
	or: 'or',
	select: 'Select',

	search: 'Search',
	search_games: 'Search Games...',
	search_assets: 'Search Assets...',
	platform: 'Platform',
	total_posts: 'Total Posts',
	total_comments: 'Total Comments',
	total_characters: 'Total Characters',
	total_assets: 'Total Assets',
	xchange_currency: 'Xchange Currency',
	subscription_days_remaining: 'Subscription Days Remaining',
	total_asset_networth: 'Total Asset Networth',
	total_character_networth: 'Total Character Networth',
	most_downloaded: 'Most Downloaded',
	recently_added: 'Recently Added',
	genre: 'Genre',
	my_library: 'My Library',
	most_commented: 'Most Commented',
	most_recent: 'Most Recent',
	nearing_addition: 'Nearing Addition',
	create_asset: 'Create Asset',
	create_character: 'Create Character',
	asset_name: 'Asset Name',
	asset_type: 'Asset Type',
	rarity: 'Rarity',
	enhancements: 'Enhancements',
	add: 'Add',
	currency_type: 'Currency Type',
	price: 'Price',
	description: 'Description',
	upload_asset: 'Upload Asset',
	preview_asset: 'Preview Asset',
	main_image: 'Main Image',
	upload_video: 'Upload Video',
	upload: 'Upload',
	view_demo: 'View Demo',
	character_name: 'Character Name',
	character_type: 'Character Type',
	upload_character: 'Upload Character',
	preview_character: 'Preview Character',
	race: 'Race',
	class: 'Class',
	gender: 'Gender',
	level: 'Level',
	showing: 'Showing',
	of: 'of',
	results: 'results',
	featured_characters: 'Featured Characters',
	url: 'URL',
	submit: 'Submit',
	real_world: 'Real World',
	game_currency: 'Game Currency',
	all: 'All',

	edit: 'Edit',
	save: 'Save',
	agg_character_networth: 'Aggregated Character Networth',
	agg_time_played: 'Aggregated Time Played',
	agg_asset_value: 'Aggregated Asset Value',
	enter_character_creation_date: 'Enter Character Creation Date',
	in_game_currency: 'In Game currency',
	real_world_value: 'Real World Value',
	update_character: 'Update Character',
	item_not_found: 'Item not found!',
	ripper: 'Ripper',
	comments: 'Comments',
	add_comments: 'Add Comments',
	new_suggested_price: 'New Suggested Price',
	sort_by: 'Sort By',
	reply: 'Reply',
	asset_networth: 'Asset Networth',
	join_date: 'Join Date',
	report: 'Report',
	first: 'First',
	last: 'Last',
	most_replies: 'Most Replies',
	new_pricing_recommendations: 'New Pricing Recommendations',
	xchange_amount: 'Xchange Amount',
	username: 'Username',
	send_gift: 'Send Gift',
	message: 'Message',
	gift_text: 'Personalize your message here',
	day: 'day',
	days: 'days',
	currency_converter: 'Currency Converter',
	from: 'From',
	to: 'To',
	in_game: 'In-game',
	real_life: 'Real-life',
	cvc: 'CVC',
	card: 'Card',
	per_month: 'Monthly($3 per month)',
	per_year: 'Annual($30 per year)',
	per_month_xchange: 'Monthly(300 Xchange per month)',
	per_year_xchange: 'Annual(3000 Xchange per year)',
	aboutUs_text: 'DigitXChange is a community-driven website that aims to finally put a value on the worth of digital goods and services via crowd-sourcing. If you\'ve ever asked the question "how much is my character actually worth" or "I wonder what a fair trade would be with another player in another game," look no further for the answers. We hope you enjoy our site, participate in building the group knowledge, show off your hard-earned loot and ultimately look forward to finding out your total digital net worth!',
	home: 'Home',
	all_time_characters: 'All Time Characters',
	this_month_characters: 'This Month Characters',
	trending_characters: 'Trending Characters',
	all_time_posters: 'All Time Posters',
	this_month_posters: 'This Month Posters',
	trending_posters: 'Trending Posters',

	result: 'result',
	pwd_msg_1: 'Password and Confirm Password does not match!',
	pwd_msg_2: 'Confirm Password is required!',
	pwd_msg_3: 'New Password is required!',
	pwd_msg_4: 'Old Password is required!',
	pwd_msg_5: 'Old Password not matched!',
	invalid_email: "Invalid Email!",
	first_name_required: 'First Name is required!',
	last_name_required: 'Last Name is required!',
	email_required: 'Email is a required!',
	account_pending: 'Your account is pending now!',
	select_game: 'Please select a game!',
	character_name_required: 'Character name is required!',	
	select_character_type: 'Please select a character type!',
	select_race: 'Please select a race!',
	select_class: 'Please select a class!',
	select_gender: 'Please select a gender!',
	asset_name_required: 'Asset name is required!',	
	select_asset_type: 'Please select an asset type!',
	select_currency: 'Please select an currency!',
	select_rarity: 'Please select a rarity!',
	signupForUpdates: 'Sign up for updates',
	message_required: 'Message is a required!',
	character_updated: 'The character has been successfully updated!',


};

export default en;


// WEBPACK FOOTER //
// ./src/translations/en.js